import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

const CTR_OVERLAY_HEIGHT = 36
const OVERLAY_HORIZONTAL_PADDING = 6

export const ctrText: React.CSSProperties = {
  ...sharedStyles.text,
  color: sharedStyles.Colors.PRIMARY,
  whiteSpace: 'nowrap',
}

export const wrapper: React.CSSProperties = {
  position: 'relative',
  height: 0,
}

export const ctrOverlay: React.CSSProperties = {
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: toPx(sharedStyles.BorderRadius.EXTRA_SMALL),
  right: toPx(0),
  top: toPx(sharedStyles.Spacings.NORMAL * -1),
  paddingLeft: toPx(OVERLAY_HORIZONTAL_PADDING),
  paddingRight: toPx(OVERLAY_HORIZONTAL_PADDING),
  backgroundColor: sharedStyles.Colors.Tints.NEUTRAL[7],
}
